import { CategoryDetailPage } from '@/components/categories/CategoryDetailPage';
import { createFileRoute } from '@tanstack/react-router';

type CategorySearchParams = {
  reportId?: string;
  dateFrom?: string;
  dateTo?: string;
};

export const Route = createFileRoute('/dashboard/categories/$categoryId')({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>): CategorySearchParams => {
    return {
      reportId: search.reportId as string | undefined,
      dateFrom: search.dateFrom as string | undefined,
      dateTo: search.dateTo as string | undefined,
    };
  },
});

function RouteComponent() {
  const { categoryId } = Route.useParams();
  const { reportId, dateFrom, dateTo } = Route.useSearch();

  const handleBack = () => {
    window.history.back();
  };

  return (
    <CategoryDetailPage
      reportId={reportId}
      categoryId={categoryId}
      dateFrom={dateFrom}
      dateTo={dateTo}
      onBack={handleBack}
    />
  );
}
